export const fmtEur = (n) => n === null || n === undefined ? "—" : Number(n).toLocaleString("cs-CZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
export const fmtKc = (n) => n === null || n === undefined ? "—" : Number(n).toLocaleString("cs-CZ", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Kč";
export const fmtRate = (r) => r === null || r === undefined ? "—" : Number(r).toLocaleString("cs-CZ", { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + " Kč/€";
export const fmtDate = (iso) => iso ? new Date(iso + (iso.length === 10 ? "T12:00:00" : "")).toLocaleDateString("cs-CZ") : "—";

export const boxesFor = (m2, m2PerBox) => {
    const per = Number(m2PerBox) || 0;
    const want = Number(m2) || 0;
    if (!per || want <= 0) return { boxes: 0, m2: 0 };
    const boxes = Math.ceil(Math.round((want / per) * 1e6) / 1e6);
    return { boxes, m2: Math.round(boxes * per * 100) / 100 };
};

export const articleLabel = (a) => `${a.supplier || "Tuscania"} ${a.collection} — ${a.color}, ${a.format}${a.finish ? ` ${a.finish}` : ""}`;
